import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    item: null,
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  blockDesign: {
    themeColor: '#5f7fff',
    themeTextColor: '#ffffff',
    layout: '2',
    view: 'card',
  },
  itemDesign: {},
  buttonDesign: {},
  containerDesign: {},
  blockSettings: {
    isComment: false,
    isName: false,
    isPhone: false,
  },
};

export const donationSlice = createSlice({
  name: 'donation',
  initialState,
  reducers: {
    donationStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign, blockSettings } = block;
      const { itemDesign, buttonDesign, containerDesign } = blockDesign;
      const { isComment, isName, isPhone } = blockSettings;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.buttonDesign = buttonDesign ?? {};

      // state.itemDesign = {
      //   shape: itemDesign.shape ?? 'round',
      //   border: itemDesign.border ?? 'none',
      //   borderColor: itemDesign.borderColor ?? '#000000',
      //   shadow: itemDesign.shadow ?? 'none',
      //   shadowColor: itemDesign.shadowColor ?? '#000000',
      // };
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        item: blockContent.item ?? null,
        heading: {
          ...blockContent.heading,
          title: blockContent.heading.title ?? '',
          description: blockContent.heading.description ?? '',
          textAlign: blockContent.heading.textAlign ?? 'left',
          image: blockContent.heading.image ?? '',
          divider: blockContent.heading.divider ?? '',
          position: blockContent.heading.position ?? '',
        },
      };

      state.blockDesign = {
        ...blockDesign,
        layout: String(blockDesign.layout ?? '2'),
        view: blockDesign.view ?? 'card',
        themeColor: blockDesign.themeColor ?? '#5f7fff',
        themeTextColor: blockDesign.themeTextColor ?? '#ffffff',
        // Preserve nested design groups on reload — the editor/preview read paddings, button
        // and item styling from blockDesign.*, so dropping them here reset them after refresh.
        containerDesign: containerDesign ?? {},
        buttonDesign: buttonDesign ?? {},
        itemDesign: itemDesign ?? {},
      };

      state.blockSettings = {
        isComment: blockSettings.isComment ?? false,
        isName: blockSettings.isName ?? false,
        isPhone: blockSettings.isPhone ?? false,
      };
    },
    donationClear: () => initialState,

    donationUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    donationUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    donationUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    donationUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
    donationUpdateBlockSettings: (state, action) => {
      state.blockSettings = action.payload;
    },
    donationSetItem: (state, action) => {
      state.blockContent.item = action.payload ?? null;
    },
  },
});

export const {
  donationStore,
  donationClear,
  donationUpdateIsLoading,
  donationUpdateIsActive,
  donationUpdateBlockContent,
  donationUpdateBlockDesign,
  donationUpdateBlockSettings,
  donationSetItem,
} = donationSlice.actions;

export const selectDonationIsLoading = (state) => state.donation.isLoading;

export const selectDonationId = (state) => state.donation.id;
export const selectDonationUID = (state) => state.donation.uid;
export const selectDonationSID = (state) => state.donation.sid;

export const selectDonationBlockContent = (state) => state.donation.blockContent;
export const selectDonationBlockDesign = (state) => state.donation.blockDesign;
export const selectDonationBlockSettings = (state) => state.donation.blockSettings;
// export const selectDonationSortItems = createSelector([selectDonationBlockContent], ({ items }) => {
//   return sortItems(items);
// });

export const selectDonationItemDesign = (state) => state.donation.itemDesign;
export const selectDonationContainerDesign = (state) => state.donation.containerDesign;
export const selectDonationButtonDesign = (state) => state.donation.buttonDesign;

export default donationSlice.reducer;
